/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type CallStatus = (typeof CallStatus)[keyof typeof CallStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CallStatus = {
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  PAUSED: 'PAUSED',
  INVITED: 'INVITED',
  EXPIRED: 'EXPIRED',
  INITIATED: 'INITIATED',
  CALLING: 'CALLING',
  CONNECTED: 'CONNECTED',
  IN_PROGRESS: 'IN_PROGRESS',
  AWAIT_PROCESSING: 'AWAIT_PROCESSING',
  COMPLETED: 'COMPLETED',
  VOICEMAIL: 'VOICEMAIL',
  NO_ANSWER: 'NO_ANSWER',
  INVALID_CONTACT: 'INVALID_CONTACT',
  WRONG_NUMBER: 'WRONG_NUMBER',
  RESCHEDULED: 'RESCHEDULED',
  INCOMPLETE: 'INCOMPLETE',
  NOT_INTERESTED: 'NOT_INTERESTED',
  CONSENT_REVOKED: 'CONSENT_REVOKED',
  DISQUALIFIED: 'DISQUALIFIED',
  FAILED_KNOCKOUT: 'FAILED_KNOCKOUT',
  NONE: 'NONE',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
  HUMAN_REVIEW_REQUESTED: 'HUMAN_REVIEW_REQUESTED',
  REVIEW_REQUESTED: 'REVIEW_REQUESTED',
  OTHER_INTERVIEW: 'OTHER_INTERVIEW',
  NEW_INTERVIEW_REQUESTED: 'NEW_INTERVIEW_REQUESTED',
  INTERVIEW_REISSUE_REJECTED: 'INTERVIEW_REISSUE_REJECTED',
  ACCOMMODATION_REQUESTED: 'ACCOMMODATION_REQUESTED',
  REDIRECTED: 'REDIRECTED',
} as const;
